import { IconProp } from '@fortawesome/fontawesome-svg-core'
import icons from '../constants/icons'

export type OrderStatusType = 'paid' | 'shipped' | 'open' | 'pending'

const getOrderStatusIcon = (status: OrderStatusType): IconProp => {
  switch (status) {
    case 'paid':
      return [icons.faIconStyle, 'money-bill-wave']
    case 'shipped':
      return [icons.faIconStyle, 'truck-moving']
    case 'open':
      return [icons.faIconStyle, 'shopping-cart']
    case 'pending':
      return [icons.faIconStyle, 'hand-holding-box']
  }
}

export default getOrderStatusIcon
